module.exports = __webpack_public_path__ + "img/zahoczky_csenge.d769c133.jpg";